import React from 'react';
import { initLanguage, changeLanguage } from 'i18n';

export const useI18n = (code: string): { loading: boolean } => {
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    const init = async () => {
      const { lang } = window;
      await initLanguage(lang, code);
      await changeLanguage(code);
    };

    setLoading(true);
    init().finally(() => setLoading(false));
  }, [code]);

  return { loading };
};
